module.exports = __webpack_public_path__ + "static/img/connect-img-left.44d4bd7e.png";